import {t} from "../i18n.js";

export default class SubscriptionsStep {
    constructor() {
        this.id = "subscriptions";
        this.title_key = "choose_subscription";
    }

    init({$, state, data, emit}) {
        this.$ = $
        this.state = state;
        this.data = data;
        this.emit = emit;
        this.selected = state.selectedEmployee || null;
        this.subscriptions = this.data.auth?.user?.all_relevant_subscription_purchases || [];
        const used_for = this.state.isClass ? "class" : "appointment";
        let validSubscriptions = this.subscriptions
            .filter(sub => sub.isActive)
            .filter(sub => sub.used_for === used_for);
        if(this.state.selectedClass) {
            const { selectedServices } = this.state;
            const mode = "any"; // "any" or "all"
            const predicate =
                mode === "any"
                    ? sub => selectedServices.some(id => sub.service_ids.includes(id))
                    : sub => selectedServices.every(id => sub.service_ids.includes(id));
            validSubscriptions = validSubscriptions.filter(predicate);
        }
        this.validSubscriptions = validSubscriptions;
    }

    render(container) {
        const isAuth = this.data.auth.isAuth;
        const userHasSubscriptions = this.validSubscriptions.length > 0;

        // === Choose rendering mode here ===
        const subscriptionCards = this.renderActiveSubscriptions(this.validSubscriptions);
        // const subscriptionCards = this.renderAllSubscriptionsWithRenew(this.validSubscriptions);

        const loginCard = `
                <div class="step-specialist-block justify-content-between" data-step="login">
                    <div class="step-specialist-body flex-grow-1">
                        <p class="step-specialist-name">${t('subscription.login_title')}</p>
                        <p class="step-specialist-job">${t('subscription.login_text')}</p>
                    </div>
                    <div class="step-specialist-arrow"></div>
                </div>
        `;
        const buyCard = `
                <div class="step-specialist-block justify-content-between" data-step="shop">
                    <div class="step-specialist-body flex-grow-1">
                        <p class="step-specialist-name">${t('subscription.buy_title')}</p>
                        <p class="step-specialist-job">${t('subscription.buy_text')}</p>
                    </div>
                    <div class="step-specialist-external"></div>
                </div>
        `;

        const html = `
        <div id="booking-step-calendar" data-step="0" class="booking-step active">
            <div class="step-main-row">
                <div class="step-specialist-list">
                    ${ isAuth ? `` : loginCard }
                    ${ userHasSubscriptions ? subscriptionCards.join('') : buyCard }
                </div>
                <div class="step-specialist-list">
                    <div class="step-specialist-block justify-content-between" data-step="skip">
                        <div class="step-specialist-body flex-grow-1">
                            <p class="step-specialist-name">${t('subscription.skip')}</p>
                        </div>
                        <div class="step-specialist-arrow"></div>
                    </div>
                </div>
            </div>
        </div>
        `
        container.html(html);
        this.bindEvents(container);
    }

    // Show only active subscriptions
    renderActiveSubscriptions(subscriptions) {
        return subscriptions
            .map(sub => {
                const serviceNames = sub.service_ids
                    .map(id => this.data.services[id])
                    .filter(service => service) // skips null or undefined
                    .map(service => service.name)
                    .join(', ');
                const translationData = {
                    diff: sub.quantity - sub.used,
                    total: sub.quantity
                };
                const subLine = t('subscription.sub_line', translationData);
                return `
            <div class="step-specialist-block justify-content-between" data-step="subscription" data-id="${sub.id}">
                <div class="step-specialist-body flex-grow-1">
                    <p class="step-specialist-name" style="
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: flex-start;
">
                        ${sub.title}
                        <small>${sub.description}</small>
                        <small style="
    font-style: italic;
    color: #888;
">${serviceNames}</small>
                        <i class="badge badge-info badge-pill" style="
    padding-block: 6px;
    background-color: color-mix(in srgb, var(--clr-primary), transparent 80%);
    font-style: normal;
    font-weight: 500;
    color: #333;
">${subLine}</i>
                    </p>
                </div>
                <div class="step-specialist-arrow"></div>
            </div>
                `;
            });
    }

    // Show all subscriptions, inactive ones have "Renew" button
    renderAllSubscriptionsWithRenew(subscriptions) {
        return subscriptions.map(sub => {
            const isActive = sub.isActive;
            const buttonText = isActive ? 'Folosește' : 'Renew';
            return `
            <div class="card p-3 text-center" data-step="subscription" data-id="${sub.id}">
                <h4>${sub.title}</h4>
                <p>${sub.description}</p>
                <button class="btn btn-primary">${buttonText}</button>
            </div>
        `;
        });
    }

    bindEvents(container) {
        const $ = this.$;

        $('.step-specialist-block', container).on('click', (e) => {
            const $item = $(e.currentTarget);
            const nextStep = $item.data('step');
            switch (nextStep) {
                case 'login': this.emit('sub_login'); break;
                case 'shop': this.emit('sub_shop'); break;
                case 'skip': this.emit('sub_selected', {subscription: -1} ); break;
                case 'subscription':
                    const subscriptions = this.data.auth.user.all_relevant_subscription_purchases || [];
                    const subscriptionId = $item.data('id');
                    const subscription = subscriptions.find(sub => sub.id === subscriptionId);
                    this.emit('sub_selected', {subscription} );
                    break;
                default:
                    break;
            }
        });
    }

    next() {
        this.state.selectedSubscription = null;
        this.state.selectedServices = [];
        this.emit('sub_next');
    }
};